<template>
  <div
    :id="`datepicker-${_uid}`"
    ref="datepickerWrapper"
    class="datepicker">
    <v-menu
      v-model="datePickerOpen"
      :close-on-click="false"
      :close-on-content-click="false"
      :offset-overflow="true"
      :disabled="disabled"
      max-width="290px"
      min-width="290px"
      offset-y>
      <template v-slot:activator="{}">
        <v-text-field
          :id="inputId"
          :outlined="!lineBottom"
          :filled="!lineBottom"
          hide-details
          v-model="dateTextModel"
          placeholder="mm/dd/yyyy"
          append-icon="mdi-calendar"
          :disabled="disabled"
          :label="label"
          @blur="debouncedDateTextModelSet.flush()"
          @focus.stop="datePickerOpen = true;"
          autocomplete="off">
        </v-text-field>
      </template>
      <v-date-picker
        ref="datepickerPicker"
        locale="en-in"
        v-model="datePickerModel"
        @input="datePickerOpen = false;"
        no-title>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

const dateDisplayFormat = 'M/D/YYYY';
const dateFormat = 'YYYY-MM-DD[T]HH:mm:ssZ';

export default {
  name: 'DatePicker',
  props: [
    'input-id',
    'value',
    'disabled',
    'lineBottom',
    'label',
  ],
  data() {
    return {
      datePickerOpen: false,
      date: undefined,
    };
  },
  computed: {
    dateTextModel: {
      get() {
        const date = moment(this.date, dateFormat);

        if (date.isValid()) {
          return date.format(dateDisplayFormat);
        }

        return '';
      },
      set(dateTextModel) {
        this.debouncedDateTextModelSet(dateTextModel);
      },
    },
    datePickerModel: {
      get() {
        const date = moment(this.date, dateFormat);

        if (date.isValid()) {
          return date.format(dateFormat);
        }

        return '';
      },
      set(datePickerModel) {
        this.setDate(datePickerModel, dateFormat);
      },
    },
  },
  watch: {
    value(value) {
      this.setDate(value, dateFormat);
    },
    date(date) {
      this.$emit('input', date);
    },
  },
  methods: {
    dateTextModelSet(dateTextModel) {
      this.setDate(dateTextModel, dateDisplayFormat);
    },
    setDate(value, format) {
      const date = moment(value, format);

      if (date.isValid()) {
        this.date = date.format(dateFormat);
      } else {
        this.date = undefined;
      }
    },
    offClickClose(e) {
      if (this.datePickerOpen
        && !this.$refs.datepickerWrapper.contains(e.target)
        && !this.$refs.datepickerPicker.$el.contains(e.target)) {
        this.datePickerOpen = false;
      }
    },
  },
  created() {
    this.setDate(this.value, dateFormat);
    this.debouncedDateTextModelSet = _.debounce(this.dateTextModelSet, 2000);
    document.addEventListener('mouseup', this.offClickClose);
  },
  destroyed() {
    document.removeEventListener('mouseup', this.offClickClose);
  },
};
</script>

<style lang="scss">
.datepicker {
  .v-input__icon--append {
    margin-top: 1px;
  }
}
</style>
